import { FC } from 'react'

import { useVoiceRecorder } from '../../hooks/useVoiceRecorder'

type Props = {
  onTranscribed: (audio: Blob) => Promise<void>
  disabled?: boolean
}

const formatSeconds = (seconds: number) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`

// bouton micro : enregistre jusqu'à 60 s puis envoie l'audio à la transcription serveur (Whisper)
const VoiceNoteButton: FC<Props> = ({ onTranscribed, disabled }) => {
  const recorder = useVoiceRecorder({ maxDurationSeconds: 60, onRecorded: onTranscribed })

  if (!recorder.isSupported) return null

  const isRecording = recorder.status === 'recording'
  const isBusy = recorder.status === 'requesting' || recorder.status === 'processing'

  const label = (() => {
    if (recorder.status === 'requesting') return 'Accès au micro…'
    if (recorder.status === 'processing') return 'On transcrit votre message…'
    if (isRecording) return `Je vous écoute… ${formatSeconds(recorder.remainingSeconds)} · Appuyez pour terminer`
    return 'Vous préférez parler ? Dictez votre activité'
  })()

  return (
    <div className="w-full">
      <button
        type="button"
        disabled={disabled || isBusy}
        onClick={isRecording ? recorder.stop : recorder.start}
        aria-pressed={isRecording}
        className={`w-full flex items-center justify-center gap-3 rounded-xl border-2 py-3 px-4 font-medium transition
          ${isRecording ? 'border-red-500 bg-red-50 text-red-700' : 'border-dashed border-new-dark-gray/40 bg-white hover:border-black'}
          ${(disabled || isBusy) ? 'opacity-70 cursor-wait' : ''}`}
      >
        <span className={`relative flex h-9 w-9 items-center justify-center rounded-full ${isRecording ? 'bg-red-500' : 'bg-black'}`}>
          {isRecording && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-60" />}
          {recorder.status === 'processing'
            ? <img className="h-4 w-4 relative" src="/assets/images/spinner-white.gif" alt="" />
            : (
              <svg className="relative h-5 w-5 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 14a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v5a3 3 0 0 0 3 3Z" />
                <path d="M19 11a1 1 0 1 0-2 0 5 5 0 0 1-10 0 1 1 0 1 0-2 0 7 7 0 0 0 6 6.92V20H8a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-3v-2.08A7 7 0 0 0 19 11Z" />
              </svg>
            )}
        </span>
        <span className="text-left text-sm md:text-base">{label}</span>
      </button>
      {recorder.error && (
        <div className="mt-2 text-xs text-red-600 text-left">{recorder.error}</div>
      )}
    </div>
  )
}

export default VoiceNoteButton
